import { ESRManpowerColumns } from "./types";
import * as yup from "yup";

export const ESRManhourInitialValues: ESRManpowerColumns = {
  id: "",
  mechanicId: "",
  mechanicName: "",
  manHours: 0,
};

export const ESRManhourSchema = yup.object({
  id: yup.string().nullable(),
  mechanicId: yup.string(),
  mechanicName: yup.string().required("Manpower is required"),
  manHours: yup.number().required('Man Hours is required').typeError('Must be a number').positive('Must be more than 0').integer('Must not contain decimals'),
});
